import axios from "@standard/axios";
import { FormService } from "@standard/services";

export const authenDocument = (role, id, status, { message, assets }) => {
  const url = `transaction/jobauthen/${role}`;
  const params = {
    id,
    status,
    message: message || "",
    assets,
  };

  return FormService.submitRequestWithFile(url, params, { showPopup: false });
};

export const requestAuthen = (jobId) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .put(`transaction/jobupload/requestauthen/${jobId}`)
      .then((res) => resolve(res.data))
      .catch((errors) => reject(errors));
  });

  return promise;
};
